import CartApiService from '@package/core/src/shoppingCart/CartApiService';
import CartInteractor from '@package/core/src/shoppingCart/CartInteractor';
import { Product } from '@package/core/src/shoppingCart/types';

import { apiClient, cookieStorage, listrakAnalytic } from '../services';
import { useStrictQuery } from '../useCustomQuery';

import { SUGGESTED_PRODUCTS_DATA_QUERY_KEY } from './types';

const cartService = new CartApiService(apiClient, cookieStorage, listrakAnalytic);
const cartInteractor = new CartInteractor(cartService);

export default function useSuggestedProducts(products: Array<Product>, vendorId: number, minPrice: number) {
  const excludeIds = [] as Array<string>;
  products.map((product: Product) => excludeIds.push(product.id));

  const { data: suggestedProducts, isFetched } = useStrictQuery(
    [SUGGESTED_PRODUCTS_DATA_QUERY_KEY, vendorId, minPrice],
    async () => {
      if (vendorId && minPrice) {
        const res = await cartInteractor.getSuggestedProducts({
          vendorId,
          minPrice,
          excludeIds: excludeIds.join(','),
        });

        return res.data;
      }
    },
  );

  return { isFetched, suggestedProducts };
}
